module.exports = __webpack_public_path__ + "img/payments.7be3f08a.svg";